import React, { useEffect, useRef, useState } from 'react';
import './Navbar.css';
import { useTheme } from './ThemeContext';

export default function Navbar() {
  const { isDark } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const lastScrollY = useRef(0);       // Persistent scroll position
  const ticking = useRef(false);       // Avoid excessive updates

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false); // collapse mobile menu
  };

  const updateNavbarVisibility = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
      // Scrolling down and not at top
      setShowNavbar(false);
      setMenuOpen(false); // collapse mobile menu
    } else if (currentScrollY < lastScrollY.current - 10) {
      // Scrolling up by at least 10px
      setShowNavbar(true);
    }

    lastScrollY.current = currentScrollY;
    ticking.current = false;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(updateNavbarVisibility);
        ticking.current = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isDark ? 'dark' : 'light'} ${showNavbar ? 'visible' : 'hidden'}`}>
      <div className="nav-left">
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>☰</div>
        <div className="desktop-links">
          <button className={`nav-btn ${isDark ? 'light' : 'dark'}`} onClick={() => scrollTo('skills')}>Projects</button>
          <button className={`nav-btn ${isDark ? 'light' : 'dark'}`} onClick={() => scrollTo('timeline')}>Qualification</button>
          <button className={`nav-btn ${isDark ? 'light' : 'dark'}`} onClick={() => scrollTo('languages')}>Languages</button>
        </div>
      </div>

      <div className={`nav-center ${isDark ? 'light' : 'dark'}`} onClick={() => scrollTo('about')}>
        Saksham
      </div>

      <div className="nav-right">
        <button className={`contact-btn ${isDark ? 'light' : 'dark'}`} onClick={() => scrollTo('contact')}>
          Contact
        </button>
      </div>

      {menuOpen && (
        <div className={`mobile-menu ${isDark ? 'dark' : 'light'}`}>
          <button className={`nav-btn ${isDark ? 'light' : 'dark'}`} onClick={() => scrollTo('skills')}>Projects</button>
          <button className={`nav-btn ${isDark ? 'light' : 'dark'}`} onClick={() => scrollTo('timeline')}>Qualification</button>
          <button className={`nav-btn ${isDark ? 'light' : 'dark'}`} onClick={() => scrollTo('languages')}>Languages</button>
        </div>
      )}
    </nav>
  );
}
